<template>
    <div class="md user-func">
        <ul>
            <li
                v-for="item in node"
                :key="item.sn || $okaTool.getUUID()"
                :class="[item.icon? 'is-'+ item.icon: '', item.active? 'is-active': '']"
            >
                <router-link
                    v-if="item.path"
                    :to="item.path"
                ></router-link>
                <a
                    v-else
                    @click.prevent="clickFunc(item)"
                ></a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: {
            node: {
                type: Array,
                require: false,
                default: function(){
                    return {}
                }
            },
        },
        methods: {
            clickFunc: function(opt){
                this.$emit('click', opt);
            },
        },
    }
</script>

<style scoped lang="scss">

    .md.user-func {
        display: inline-block;
        vertical-align: middle;

        .lo.header & {

            @include media('mobile') {
                display: none;
            }
        }

        .lo.section & {

            @include media('phone') {
                display: none;
            }

            li {

                &:last-child {
                    border-right-width: 0;
                }
            }
        }

        ul {
            @extend %reset;
            text-align: center;
        }

        li {
            @extend %header-btn;

            + li {
                padding-left: 0;
            }

            .lo.content & {
                border-right-color: $minor-color;

                a {
                    background-color: $minor-color;

                    &:hover {
                        opacity: $opacity-h;
                    }

                    &::before {
                        color: $forth-color;
                    }
                }

                &.is-active {

                    > a {
                        background-color: $forth-color;

                        &::before {
                            color: $white;
                        }
                    }
                }
            }

            &.is-active {

                > a {
                    background-color: $major-color;

                    &::before {
                        color: $white;
                    }
                }
            }

            &.is-chart {

                a {

                    &::before {
                        content: '\e6e1';
                    }
                }
            }

            &.is-price {

                a {

                    &::before {
                        content: '\e227';
                    }
                }
            }

            &.is-table {

                a {

                    &::before {
                        content: '\e9b0';
                    }
                }
            }

            &.is-list {

                a {

                    &::before {
                        content: '\f06d';
                    }
                }
            }
        }

        a {
            
        }
    }
</style>
